import { render, staticRenderFns } from "./SLACardLabel.vue?vue&type=template&id=594618e9&"
import script from "./SLACardLabel.vue?vue&type=script&lang=js&"
export * from "./SLACardLabel.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports